import * as React from 'react'
import { get, has, isNil, isArray, first } from 'lodash'
import { useFormikContext } from 'formik'

const withFormik = (Component: React.ComponentType<any>) => {
  const Inner = (props: any) => {
    const formik = useFormikContext()
    const touched = get(formik.touched, props.name)
    const onBlur = formik.handleBlur
    const onChange = props.onChange || formik.handleChange

    const errorMessageOrErrors = get(formik.errors, props.name)
    const errorMessage = isArray(errorMessageOrErrors)
      ? first(errorMessageOrErrors)
      : errorMessageOrErrors

    const error = isNil(props.error)
      ? (touched || formik.submitCount > 0) && Boolean(errorMessage)
      : props.error

    const value = isNil(props.value)
      ? has(formik.values, props.name)
        ? get(formik.values, props.name)
        : ''
      : props.value

    const helperText = isNil(props.helperText)
      ? error
        ? errorMessage
        : ''
      : props.helperText

    return (
      <Component
        {...props}
        formik={formik}
        onBlur={onBlur}
        onChange={onChange}
        error={error}
        value={value}
        helperText={helperText}
      />
    )
  }

  return Inner
}

export default withFormik
